



















import { Component, Vue } from 'vue-property-decorator';
import jobsRepository from '@/modules/jobs/jobsRepository';
import notificationService from '../../../services/notificationService';

@Component({
  components: {
  },
})
export default class JobsOverviewPage extends Vue {
  private executingJob: boolean = false;

  private async GenerateInvoicesForRentals() {
    try {
      this.executingJob = true;
      await jobsRepository.generateInvoicesFromMachineryRental();
      notificationService.showSuccessMessage('Facturen gegenereerd');
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.executingJob = false;
    }
  }

}
